import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, registerLazyOrchestrator } from 'owa-bundling';
import onMessageReadEventCompleted from 'owa-addins-store/lib/actions/onMessageReadEventCompleted';
import onReadItemSwitch from 'owa-addins-store/lib/actions/onReadItemSwitch';
import { onReadingPaneLoaded } from 'owa-mail-reading-pane-store-conversation/lib/actions/onReadingPaneLoaded';
import onItemPartSelected from 'owa-mail-reading-pane-store-conversation/lib/actions/onItemPartSelected';
import triggerOnDemandDecryption from 'owa-mail-reading-pane-store-conversation/lib/actions/triggerOnDemandDecryption';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AddinsDecryption" */ './lazyIndex'),
    {
        name: 'AddinsDecryption',
    }
);

export const lazyProcessItemForDecryption: LazyAction<
    typeof lazyIndex.processItemForDecryption,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.processItemForDecryption);

registerLazyOrchestrator(
    onMessageReadEventCompleted,
    lazyModule,
    m => m.messageReadEventCompletedOrchestrator
);

registerLazyOrchestrator(onReadItemSwitch, lazyModule, m => m.readItemSwitchOrchestrator);

registerLazyOrchestrator(
    onReadingPaneLoaded,
    lazyModule,
    m => m.onReadingPaneLoadedDecryptionOrchestrator
);

registerLazyOrchestrator(
    onItemPartSelected,
    lazyModule,
    m => m.onItemPartSelectedDecryptionOrchestrator
);

registerLazyOrchestrator(
    triggerOnDemandDecryption,
    lazyModule,
    m => m.onDemandDecryptionOrchestrator
);
